import { render, staticRenderFns } from "./penggunasistem.vue?vue&type=template&id=61c0f7c4"
import script from "./penggunasistem.vue?vue&type=script&lang=js"
export * from "./penggunasistem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports